import { useAppDispatch } from '@app/store/hooks';
import { openModal, registerModal, unregisterModal } from '@app/store/slices/modal.slice';
import { useCallback, useEffect, useMemo } from 'react';

export const useModal = <T = any>(id: string) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(registerModal({ id }));

    return () => {
      dispatch(unregisterModal(id));
    }
  }, []);

  const open = useCallback((data?: T) => {
    dispatch(openModal({ id, changes: { isOpen: true, data } }));
  }, []);

  const close = useCallback(() => {
    dispatch(openModal({ id, changes: { isOpen: false } }));
  }, []);

  return {
    id,
    open,
    close
  }
}

export type ModalInstance<T = any> = ReturnType<typeof useModal<T>>;

import React from 'react';

// type ModalInstance = {
//   id: string;
//   content: React.ReactNode;
// };

// type ModalManager = {
//   open: (content: React.ReactNode) => string;
//   close: (id: string) => void;
//   subscribe: (listener: () => void) => () => void;
//   getSnapshot: () => ModalInstance[];
// };

// const createModalManager = (): ModalManager => {
//   let modals: ModalInstance[] = [];
//   let listeners: (() => void)[] = [];

//   const notify = () => {
//     listeners.forEach((listener) => listener());
//   };

//   return {
//     open(content) {
//       const id = Math.random().toString(36).substring(2);
//       modals = [...modals, { id, content }];
//       notify();
//       return id;
//     },
//     close(id) {
//       modals = modals.filter((modal) => modal.id !== id);
//       notify();
//     },
//     subscribe(listener) {
//       listeners.push(listener);
//       return () => {
//         listeners = listeners.filter((l) => l !== listener);
//       };
//     },
//     getSnapshot() {
//       return modals;
//     },
//   };
// };

// export const modal = createModalManager();

// export const ModalContainer = () => {
//   const modals = React.useSyncExternalStore(
//     modal.subscribe,
//     modal.getSnapshot
//   );

//   return (
//     <>
//       {modals.map(({ id, content }) => (
//         <div key={id} className="modal">
//           {content}
//           <button onClick={() => modal.close(id)}>Close</button>
//         </div>
//       ))}
//     </>
//   );
// };